// Importing necessary libraries and components
import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { useSnackbar } from "notistack";
import Checkbox from "@material-ui/core/Checkbox";
import LoaderDialogBox from "components/AppLoader/LoaderDialogBox";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Box,
  Paper,
  Card,
  Typography,
} from "@mui/material";
import IconButton from "@material-ui/core/IconButton";
import { CardActions } from "@material-ui/core";
import { emptyGroupCodeReduxState } from "Redux/Actions/merchantInformation";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import MenuItem from "@material-ui/core/MenuItem";
import AppLoader from "../AppLoader/Index";
import {
  profileCodePermissionCheck,
  ManagerType,
} from "../../Utils/commonUtils";
import EmailAutofillManager from "../../views/UserProfile/EmailAutofillManager";
import {
  getMerchantListData,
  getManagerListDataNames,
  getEmailList,
  getEmailData,
  emptyEmailListReduxState,
} from "../../Redux/Actions/merchantInformation";
import {
  sendInviteManagerApiCall,
  submitManagerApiCall,
} from "../../actions/Operations";

// Custom styles for the InviteManagerModal component
const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    borderRadius: 8,
    maxWidth: 600,
    width: "90%",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
  },
  button: {
    marginTop: theme.spacing(3),
  },
  inputRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: theme.spacing(1),
    },
  },
}));

// Utility function to format phone numbers
function formatPhoneNumber(v) {
  // Ensure `v` is a string or coerce to a string
  if (typeof v !== "string") {
    v = String(v || ""); // Convert to string, default to an empty string if null or undefined
  }

  let r = v.replace(/\D/g, ""); // Remove non-digit characters

  if (r.length > 11) {
    r = r?.replace(/^(\d\d\d)(\d{3})(\d{0,4}).*/, "$1-$2-$3");
    return r;
  }
  if (r.length > 6) {
    r = r?.replace(/^(\d\d\d)(\d{3})(\d{0,4}).*/, "$1-$2-$3");
  } else if (r.length > 3) {
    r = r?.replace(/^(\d\d\d)(\d{0,3})/, "$1-$2");
  } else {
    r = r.replace(/^(\d*)/, "$1");
  }

  return r;
}

// Main component for inviting a manager
const InviteManagerModal = ({
  onClose,
  props,
  rows,
  Bussines_id,
  rowForEdit,
  handleAssignGroup,
  handleRefresh,
}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  // State variables for form inputs and modal behavior
  const [loadingModal, setLoadingModal] = React.useState(false);

  const [firstName, setFirstName] = useState("");
  const menu = JSON.parse(localStorage.getItem("menu"));
  const [assignGroupsModal, setAssignGroupsModal] = React.useState(false);
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const [phoneNumber, setPhone] = useState("");

  const [isAllSelected, setIsAllSelected] = React.useState(false);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const businessTypeValue = [{ value: "Manager" }, { value: "Sub Manager" }];
  const platformAccessibility = [{ value: "WEB" }, { value: "API" }];
  const [achValue, setACHValue] = React.useState(false);
  const [businessName, setBusinessName] = useState(null);
  const [businessType, setBusinessType] = useState("");
  const [loading, setLoading] = React.useState(false); // State to manage loading state
  const [selectedGroupVisibility, setSelectedGroupVisibility] = useState(null);
  const [selectedCheckbox, setSelectedCheckbox] = useState();
  const [selectedEmail, setSelectedEmail] = useState();
  const [selectedBusinessId, setSelectedBusinessId] = useState();
  const [selectedManagerId, setSelectedManagerId] = useState();
  const [selectedUser, setSelectedUser] = React.useState({});
  const [platformType, setPlatformType] = useState();
  const [existingPlatformAccessibility, setExistingPlatformAccessibility] =
    useState("");
  const [buttonFlag, setButtonFlag] = useState(false);
  const [selectBusinessID, setSelectBusinessID] = useState([]);
  const merchantList = props?.merchantListData?.merchantListData;
  const dispatch = useDispatch();
  const tableData =
    props.merchantGroupCodeListPortfolios &&
    props.merchantGroupCodeListPortfolios.data;
  const Profile_id = localStorage.getItem("profileId");
  const [mainEmail, setMainEmail] = React.useState("");
  const [mainManagerId, setMainManagerId] = React.useState("");
  const profileCode = menu?.Role_Permission_Data?.Profile_Code;
  const [accountAccessibility, setAccountAccessibility] = React.useState([]);
  const ManagerUid = localStorage.getItem("Manager_uid");

  let Manager_uid = null;
  try {
    Manager_uid = ManagerUid ? JSON.parse(ManagerUid) : null;
  } catch (error) {
    console.error("Error parsing ManagerUid:", error);
  }

  const User_Id = localStorage.getItem("User_Id");
  const businessNameData = localStorage.getItem("businessName");

  React.useEffect(() => {
    let completeDataMerchant = props.merchantListData?.merchantListData;

    if (!Array.isArray(completeDataMerchant)) {
      completeDataMerchant = props.merchantListData?.merchantListData?.data;
    }

    if (!Array.isArray(completeDataMerchant)) {
      return;
    }

    const matchedMerchant = completeDataMerchant.find(
      (merchant) => String(merchant?._id) === String(rowForEdit?.Bussines_id)
    );

    if (matchedMerchant) {
      setMainEmail(matchedMerchant.Manager_Details?.Email);
      setMainManagerId(matchedMerchant.Manager_Details?._id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowForEdit, props?.merchantListData?.merchantListData]);

  React.useEffect(() => {
    const completeDataMerchant = props.merchantListData?.merchantListData;

    if (completeDataMerchant && typeof completeDataMerchant === "object") {
      const selectedBusinessIDs =
        props?.merchantListData?.merchantListData?.data
          ?.filter((item) => item.Status_Code === 3)
          .map((row) => row._id) || []; // Ensure it's always an array

      if (selectedBusinessIDs.length > 0) {
        setSelectBusinessID(selectedBusinessIDs);
      } else {
        setSelectBusinessID([]); // Reset state to an empty array if no data is found
      }
    } else {
      setSelectBusinessID([]); // Handle the case where merchantListData is missing
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowForEdit, props.merchantListData?.merchantListData]);

  React.useEffect(() => {
    const Manager_Id = menu?.Manager_Id;
    if (
      menu?.Role_Permission_Data?.Profile_Code ===
      profileCodePermissionCheck.profileCode.SA
    ) {
      let payload = null;
      if (Profile_id === null || Profile_id === "null") {
        payload = {
          Manager_Id,
          recordPerPage: 999999,
        };
      } else {
        payload = {
          Profile_id,
          recordPerPage: 999999,
        };
      }
      props.getMerchantListData(payload);
    } else {
      const payload = {
        Profile_Code: menu?.Role_Permission_Data?.Profile_Code,
        recordPerPage: 999999,
      };
      props.getMerchantListData(payload);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Profile_id, profileCode]);

  React.useEffect(() => {
    const data =
      props.merchantListData.merchantListData &&
      props.merchantListData.merchantListData.data;
    if (data) {
      setLoadingModal(false);
      const setACHValueHandle = () => {
        if (rowForEdit?.Account_Accessibility) {
          for (const item of rowForEdit.Account_Accessibility) {
            if (item.Service_Code === "ACH") {
              handleCheckboxChangeRtpAch(true, "ACH");
            }
          }
        }
      };

      const setRTPValueHandle = () => {
        if (rowForEdit?.Account_Accessibility) {
          for (const item of rowForEdit.Account_Accessibility) {
            if (item.Service_Code === "RTP") {
              handleCheckboxChangeRtpAch(true, "RTP"); // Set to true if any "RTP" has "Check: true", otherwise false
            }
          }
        }
      };

      setACHValueHandle();
      setRTPValueHandle();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, rowForEdit]);
  React.useEffect(() => {
    const isEditMode = Boolean(Bussines_id);

    // Only run this effect for edit modes (URL-id or provided Bussines_id).
    // In fresh-invite (no Bussines_id and no rowForEdit), do NOT run here
    // because fresh-mode initialization is handled separately to avoid
    // overwriting the user's selection when merchant data arrives.
    if (isEditMode || rowForEdit?.Bussines_id) {
      rows.forEach((row) => {
        if (!businessName) {
          setBusinessName(row.Business_Name);
        }
        for (const item of row.Status_Code) {
          if (item?.Service_Code === "ACH" || item?.Service_Code === "RTP") {
            const merchantData =
              props?.merchantListData?.merchantListData?.data;

            if (Array.isArray(merchantData)) {
              for (const merchant of merchantData) {
                if (
                  merchant?._id === (rowForEdit?.Bussines_id || Bussines_id || selectBusinessID.length)
                ) {
                  const filtered =
                    merchant?.ManagerStatus?.Status?.filter(
                      (status) =>
                        status.Check &&
                        status.Status === "Active"
                    ) || [];

                  // In edit mode we populate selectedCheckbox from existing merchant
                  // details (preserve edit-mode behaviour).
                  setSelectedCheckbox(filtered);
                  setSelectedEmail(merchant?.Manager_Details?.Email);
                  setSelectedBusinessId(merchant?._id);
                  setSelectedManagerId(merchant?.Manager_Details?._id);

                  if (item?.Service_Code === "ACH") {
                    setSelectedGroupVisibility(
                      merchant?.Manager_Details?.Group_Visibility
                    );
                  }
                }
              }
            }

            if (isEditMode) {
              handleCheckboxChangeRtpAch(true, item?.Service_Code);
            }
          }
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    Bussines_id,
    businessNameData,
    businessName,
    selectedEmail,
    merchantList,
  ]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (rowForEdit?.User_Merchant_AcctLinks_Details) {
      // Extract Group_Visibility array and set it to selectedRows
      const userMerchantAcctLinksDetails =
        rowForEdit?.User_Merchant_AcctLinks_Details || [];
      setSelectedRows(userMerchantAcctLinksDetails);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, rowForEdit?.User_Merchant_AcctLinks_Details]);

  const handleCheckboxChangeRtpAch = (event, serviceCode) => {
    const isChecked = event === true ? true : event?.target?.checked;
    // Handle specific logic for RTP and ACH

    if (serviceCode === "ACH") {
      setACHValue(isChecked);
      setSelectedRows([]);
      setIsAllSelected(false);
    }

    // Update accountAccessibility state
    setAccountAccessibility((prev) => {
      if (isChecked || event === true) {
        // Add the new service code if checked
        return [
          ...prev.filter((item) => item.Service_Code !== serviceCode),
          { Service_Code: serviceCode, Status: "Invited", Check: isChecked },
        ];
      }
      // Remove the service code if unchecked
      return prev.filter((item) => item.Service_Code !== serviceCode);
    });
  };

  const onCloseAssign = () => {
    setAssignGroupsModal(false);
  };

  const handleCheckboxChange = (row) => {
    setSelectedRows((prevSelected) => {
      const selectedArray = Array.isArray(prevSelected) ? prevSelected : []; // Ensure it's always an array
      const isSelected = selectedArray.some((item) => item.id === row.id);
      let updatedSelection;

      if (isSelected) {
        // Remove if already selected
        updatedSelection = selectedArray.filter((item) => item.id !== row.id);
      } else {
        // Add new selection
        updatedSelection = [
          ...selectedArray,
          {
            ...row,
            merchantCodeID: row.id,
            sendTransaction: true,
            transactionQuery: true,
          },
        ];
      }

      setIsAllSelected(updatedSelection.length === tableData?.length);
      return updatedSelection; // Return the updated selection
    });
  };

  const handleSelectAll = (event) => {
    const checked = event.target.checked;
    setIsAllSelected(checked);

    if (checked) {
      // Select all rows with both checkboxes checked
      const updatedSelection = tableData?.map((row) => ({
        ...row,
        // merchantCodeID:row.id,
        sendTransaction: true,
        transactionQuery: true,
      }));
      setSelectedRows(updatedSelection);
    } else {
      // Deselect all rows
      setSelectedRows([]);
    }
  };

  const handleSendTransactionChange = (row) => {
    setSelectedRows((prevSelected) =>
      prevSelected.map((item) =>
        item.id === row.id
          ? { ...item, sendTransaction: !item.sendTransaction }
          : item));
  };

  const handleTransactionQueryChange = (row) => {
    setSelectedRows((prevSelected) =>
      prevSelected.map((item) =>
        item.id === row.id
          ? { ...item, transactionQuery: !item.transactionQuery }
          : item));
  };

  // Function to handle form submission for sending an invite

  const onFormSendInvite = () => {
    if (!firstName || !lastName || !email || !phoneNumber || !businessName) {
      enqueueSnackbar("Please fill out all required fields.", {
        variant: "error",
      });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      enqueueSnackbar("Please enter a valid email address.", {
        variant: "error",
      });
      return;
    }
    if (platformConflict) {
      enqueueSnackbar(platformConflict, { variant: "warning" });
      return;
    }
    const startsWithNumberRegex = /^\d/;
    if (
      startsWithNumberRegex.test(firstName) ||
      startsWithNumberRegex.test(lastName)
    ) {
      enqueueSnackbar("First/Last name cannot start with a number.", {
        variant: "error",
      });
      return;
    }
    setLoading(true); // Set loading state to true when API call starts
    props.sendInviteManagerApiCall(
      {
        firstName: firstName.charAt(0).toUpperCase() + firstName.slice(1),
        lastName: lastName.charAt(0).toUpperCase() + lastName.slice(1),
        email: email.toLowerCase(),
        phoneNumber,
        businessName,
        Status_Code: 1,
        accountAccessibility,
        Group_Visibility: selectedGroupVisibility,
        Platform_Accessibility: platformType,
        groupCodes: selectedRows,
        Bussines_id: Bussines_id || selectedBusinessId,
        Profile_id: Manager_uid,
        User_Id,
        Type: `${profileCode === profileCodePermissionCheck.profileCode.VCS || profileCode === profileCodePermissionCheck.profileCode.SA
          ? businessType
          : "sub"
          }`,
      },
      (res) => {
        if (res.status === true) {
          setLoading(false); // Set loading state to false when API call is successful
          enqueueSnackbar(`${res.message}`, {
            variant: "success",
          });
          onClose();
          handleRefresh();

          // props.history.push(
          //   `/${props.mainData.app.layout}/ManagerList${props.location.search}`
          // );
          // window.location.reload();
        }
      },
      (error) => {
        setLoading(false); // Set loading state to false when API call fails
        enqueueSnackbar(`${error.message}`, {
          variant: "error",
        });
      }
    );
  };
  const onFormSubmit = () => {
    if (!firstName || !lastName || !email || !phoneNumber || !businessName) {
      enqueueSnackbar("Please fill out all required fields.", {
        variant: "error",
      });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      enqueueSnackbar("Please enter a valid email address.", {
        variant: "error",
      });
      return;
    }
    const startsWithNumberRegex = /^\d/;
    if (
      startsWithNumberRegex.test(firstName) ||
      startsWithNumberRegex.test(lastName)
    ) {
      enqueueSnackbar("First/Last name cannot start with a number.", {
        variant: "error",
      });
      return;
    }

    props.submitManagerApiCall(
      {
        firstName: firstName.charAt(0).toUpperCase() + firstName.slice(1),
        lastName: lastName.charAt(0).toUpperCase() + lastName.slice(1),
        email: email.toLowerCase(),
        phoneNumber,
        businessName,
        // Status_Code: 1,
        accountAccessibility,
        Group_Visibility: selectedGroupVisibility,
        Platform_Accessibility: platformType,
        groupCodes: selectedRows,
        Bussines_id: rowForEdit.Bussines_id,
        Profile_id: Manager_uid,
        User_Id: User_Id || null,
        managerObjId: rowForEdit.Id,
        Type: `${profileCode === profileCodePermissionCheck.profileCode.VCS || profileCode === profileCodePermissionCheck.profileCode.SA
          ? businessType
          : "sub"
          }`,
      },
      (res) => {
        if (res.status === true) {
          enqueueSnackbar(`${res.message}`, {
            variant: "success",
          });
          props.history.push(
            `/${props.mainData.app.layout}/ManagerList${props.location.search}`
          );
          window.location.reload();
        }
      },
      (error) => {
        enqueueSnackbar(`${error.message}`, {
          variant: "error",
        });
      }
    );
  };
  const businessNameHandle = (e) => {
    setBusinessName(e.target.value);
    const selectedBusinessName = e.target.value;
    handleCheckboxChangeRtpAch(false, "ACH");
    props.emptyGroupCodeReduxState();
    setSelectedRows([]);
    const matchingBusinesses =
      props?.merchantListData?.merchantListData?.data?.filter(
        (item) =>
          item.Business_Name === selectedBusinessName &&
          selectBusinessID.includes(item._id) // Corrected: using the state variable
      );

    if (matchingBusinesses.length > 0) {
      setSelectedGroupVisibility(
        matchingBusinesses[0]?.Manager_Details?.Group_Visibility
      );

      // Only perform immediate selectedCheckbox initialization here when
      // merchant list data and selectBusinessID are already available.
      if (
        props?.merchantListData?.merchantListData?.data &&
        selectBusinessID?.length > 0
      ) {
        const filtered =
          matchingBusinesses[0]?.ManagerStatus?.Status?.filter(
            (item) => item.Check && item.Status === "Active"
          ) || [];

        // Services available for this business
        setSelectedCheckbox(filtered);

        // Nothing selected initially
        setAccountAccessibility([]);
        setACHValue(false);
        setSelectedRows([]);
        setSelectedBusinessId(matchingBusinesses[0]?._id);
        setSelectedManagerId(matchingBusinesses[0]?.Manager_Details?._id);
        setSelectedEmail(matchingBusinesses[0]?.Manager_Details?.Email || ""); // Picks the first email
      }
    }
  };

  // Fresh-invite initialization: when user selected a business name but the
  // merchant list or selectBusinessID was not ready at that moment, initialize
  // `selectedCheckbox` once the data arrives. This ensures the dropdown
  // selection doesn't get lost due to timing.
  React.useEffect(() => {
    if (
      !Bussines_id &&
      !rowForEdit?.Bussines_id &&
      businessName &&
      props?.merchantListData?.merchantListData?.data &&
      selectBusinessID?.length > 0
    ) {
      const matchingBusinesses =
        props?.merchantListData?.merchantListData?.data?.filter(
          (item) =>
            item.Business_Name === businessName &&
            selectBusinessID.includes(item._id)
        ) || [];

      if (matchingBusinesses.length > 0) {
        const filtered =
          matchingBusinesses[0]?.ManagerStatus?.Status?.filter(
            (item) => item.Check && item.Status === "Active"
          ) || [];

        setSelectedGroupVisibility(
          matchingBusinesses[0]?.Manager_Details?.Group_Visibility
        );
        setSelectedCheckbox(filtered);
        setAccountAccessibility([]);
        setACHValue(false);
        setSelectedRows([]);
        setSelectedBusinessId(matchingBusinesses[0]?._id);
        setSelectedManagerId(matchingBusinesses[0]?.Manager_Details?._id);
        setSelectedEmail(matchingBusinesses[0]?.Manager_Details?.Email || "");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessName, props?.merchantListData?.merchantListData?.data, selectBusinessID]);

  React.useEffect(() => {
    if (rowForEdit?.Business_Name) {
      setBusinessName(rowForEdit?.Business_Name);
      setButtonFlag(true);
      setPlatformType(rowForEdit?.Platform_Accessibility);
      setBusinessType(rowForEdit?.Type);
    } else {
      setButtonFlag(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowForEdit]);
  const handleEmailChange = (email, agentsList) => {
    const normalizedEmail = email?.toLowerCase();
    setEmail(normalizedEmail);
    setExistingPlatformAccessibility("");

    if (normalizedEmail?.length >= 4) {
      fetchEmailList(normalizedEmail);
    } else {
      setFirstName((prevValues) => ({ ...prevValues, firstName: "" }));
      setLastName((prevValues) => ({ ...prevValues, lastName: "" }));
      setPhone((prevValues) => ({ ...prevValues, phoneNumber: "" }));
      dispatch(emptyEmailListReduxState());
    }

    const emailExists = agentsList?.includes(normalizedEmail);

    if (emailExists && /^\S+@\S+\.\S+$/.test(normalizedEmail)) {
      dispatch(getEmailData(normalizedEmail));
    }
  };

  const fetchEmailList = (email) => {
    const type = businessType === "main" ? "main" : "sub";
    dispatch(getEmailList(email, type));
  };

  const handleUserSelect = (user) => {
    setSelectedUser(user);
    setFirstName(user?.First_Name || "");
    setLastName(user?.Last_Name || "");
    setPhone(user?.Phone_Number || "");
    dispatch(emptyEmailListReduxState());
  };

  React.useEffect(() => {
    if (props?.merchantListData?.emailListData?.data && email) {
      const emailExists =
        props.merchantListData.emailListData.data.includes(email);
      if (emailExists) {
        dispatch(getEmailData(email));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.merchantListData?.emailListData?.data, email]);

  React.useEffect(() => {
    if (props?.merchantListData?.emailData) {
      const { First_Name, Last_Name, Phone_Number } =
        props?.merchantListData?.emailData;
      setFirstName(First_Name || "");
      setLastName(Last_Name || "");
      setPhone(Phone_Number || "");
      setExistingPlatformAccessibility(
        props.merchantListData.emailData.Platform_Accessibility || ""
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.merchantListData?.emailData]);
  React.useEffect(() => {
    if (rowForEdit) {
      const {
        Email, First_Name, Last_Name, Phone_Number,
      } = rowForEdit;
      setFirstName(First_Name || "");
      setLastName(Last_Name || "");
      setPhone(Phone_Number || "");
      setEmail(Email || "");
    }
  }, [rowForEdit]);

  React.useEffect(
    () => () => {
      dispatch(emptyEmailListReduxState());
      setExistingPlatformAccessibility("");
    },
    [dispatch]
  );

  const handleEmailBlur = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(email)) {
      const response = await dispatch(getEmailData(email));
      if (response && response.data) {
        const { First_Name, Last_Name, Phone_Number } = response.data;
        setFirstName(First_Name || "");
        setLastName(Last_Name || "");
        setPhone(Phone_Number || "");
        setExistingPlatformAccessibility(
          response.data.Platform_Accessibility || ""
        );
      }
    }
    if (!email) {
      clearAllFields();
    }
  };

  const clearAllFields = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setExistingPlatformAccessibility("");
  };
  const existingPlatform = existingPlatformAccessibility?.toUpperCase();
  const selectedPlatform = (
    platformType || rowForEdit?.Platform_Accessibility
  )?.toUpperCase();
  const platformConflict =
    ["WEB", "API"].includes(existingPlatform) &&
    ["WEB", "API"].includes(selectedPlatform) &&
    existingPlatform !== selectedPlatform
      ? `The invited user already exists with ${existingPlatform} Platform access. They can only be invited for the same Platform.`
      : "";
  const isInviteDisabled =
    accountAccessibility.length === 0 ||
    (accountAccessibility.some(item => item.Service_Code === "ACH") &&
      selectedRows.length === 0) ||
    Boolean(platformConflict);
  const showCheckbox =
    profileCode === profileCodePermissionCheck.profileCode.SA
      ? rowForEdit?.Account_Accessibility
      : selectedCheckbox;
  const hasACH = accountAccessibility.some(
    item => item.Service_Code === "ACH"
  );
  const firstManager = props.managerListData.merchantListData && props.managerListData.merchantListData.data[0].ManagerStatus.First_Manager_Business;
  return (
    <div>
      <Modal open={assignGroupsModal}>
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            height: "100%",
            width: "50%", // Adjust width as needed
            backgroundColor: "white",
            boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.5)",
            zIndex: 1300,
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
        >
          <LoaderDialogBox loader={loadingModal} />
          <CardActions
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <IconButton onClick={onCloseAssign}>
              <CloseIcon />
            </IconButton>
            <Typography
              style={{
                marginBottom: "10px",
                fontWeight: "600",
                paddingRight: "10px",
              }}
            >
              Selected: {selectedRows?.length} / {tableData?.length}
            </Typography>
          </CardActions>

          <Card
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              margin: "0px",
            }}
          >
            <TableContainer component={Paper} style={{ maxHeight: "90vh" }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        color="primary"
                        indeterminate={
                          selectedRows?.length > 0 &&
                          selectedRows?.length < tableData?.length
                        }
                        checked={isAllSelected}
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    <TableCell>
                      <strong>Group Code</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Name</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Code</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Account Type</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Send Transaction</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Transaction Query</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.merchantGroupCodeListPortfolios &&
                    props.merchantGroupCodeListPortfolios.data?.map(
                      (row, index) => {
                        const isRowSelected = (selectedRows ?? []).some(
                          (item) => item.id === row.id
                        );
                        const currentRow =
                          (selectedRows ?? []).find(
                            (item) => item.id === row.id
                          ) || {};

                        return (
                          <TableRow key={index}>
                            <TableCell padding="checkbox">
                              <Checkbox
                                color="primary"
                                checked={isRowSelected}
                                onChange={() => handleCheckboxChange(row)}
                              />
                            </TableCell>
                            <TableCell>{row.merchantGroupCode}</TableCell>
                            <TableCell>{row.merchantName}</TableCell>
                            <TableCell>{row.merchantCode}</TableCell>
                            <TableCell>{row.accountTypeName}</TableCell>
                            <TableCell>
                              <Checkbox
                                color="primary"
                                checked={currentRow.sendTransaction || false}
                                onChange={() =>
                                  handleSendTransactionChange(row)
                                }
                              />
                            </TableCell>
                            <TableCell>
                              <Checkbox
                                color="primary"
                                checked={currentRow.transactionQuery || false}
                                onChange={() =>
                                  handleTransactionQueryChange(row)
                                }
                              />
                            </TableCell>
                          </TableRow>
                        );
                      }
                    )}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </div>
      </Modal>
      <Modal open onClose={onClose}>
        <div className={classes.paper}>
          <AppLoader loader={loading} />
          <h2>Send Invitation</h2>
          <form onSubmit={(e) => e.preventDefault()}>
            <div className={classes.inputContainer}>
              <div className={classes.inputRow}>
                {Bussines_id == null ? (
                  <FormControl fullWidth>
                    <InputLabel htmlFor="business-name">
                      Business Name
                    </InputLabel>
                    <Select
                      disabled={rowForEdit?.Business_Name}
                      labelId="business-name"
                      id="business-name"
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left",
                        },
                        PaperProps: {
                          style: {
                            maxHeight: 200,
                          },
                        },
                      }}
                      PopoverProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left",
                        },
                        PaperProps: {
                          style: {
                            marginTop: "100px",
                            top: "119px",
                          },
                        },
                      }}
                      value={businessName}
                      onChange={(e) => businessNameHandle(e)}
                      required
                    >
                      {rowForEdit?.Business_Name ? (
                        <MenuItem value={businessName}>{businessName}</MenuItem>
                      ) : !props?.merchantListData?.merchantListData?.data ? (
                        <MenuItem disabled>Loading...</MenuItem>
                      ) : (
                        props?.merchantListData?.merchantListData?.data
                          .filter((item) => item.Status_Code === 3)
                          .sort(
                            (a, b) =>
                              new Date(b.Updated_date) -
                              new Date(a.Updated_date)
                          )
                          .map((row) => (
                            <MenuItem key={row._id} value={row.Business_Name}>
                              {row.Business_Name}
                            </MenuItem>
                          ))
                      )}
                    </Select>
                  </FormControl>
                ) : (
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      style={{
                        paddingRight: "10px",
                      }}
                      htmlFor="business-name"
                    >
                      Business Name:
                    </Typography>
                    {businessName}
                  </Box>
                )}
              </div>
              <div>
                {profileCode ===
                  (profileCodePermissionCheck.profileCode.SA ||
                    profileCodePermissionCheck.profileCode.ADM) ? (
                  <div>
                    <FormControl fullWidth>
                      <InputLabel htmlFor="business-name">
                        Manager Type
                      </InputLabel>
                      <Select
                        labelId="business-name"
                        id="business-name"
                        disabled={
                          rowForEdit?.Type ||
                          !businessName ||
                          (profileCode ===
                            profileCodePermissionCheck.profileCode.SA &&
                            firstManager === false)
                        }
                        onChange={(e) => {
                          setBusinessType(e.target.value);
                          clearAllFields();
                        }}
                        value={firstManager == false ? ManagerType.Sub : businessType}
                        required
                      >
                        {rowForEdit?.Type ? (
                          <MenuItem value={rowForEdit?.Type}>
                            {rowForEdit?.Type === "main"
                              ? "Manager"
                              : rowForEdit?.Type === "sub"
                                ? "Sub Manager"
                                : ""}
                          </MenuItem>
                        ) : (
                          businessTypeValue?.map((row) => (
                            <MenuItem
                              value={`${row.value === "Manager" ? "main" : "sub"
                                }`}
                            >
                              {row.value}
                            </MenuItem>
                          ))
                        )}
                      </Select>
                    </FormControl>
                    {(profileCode ===
                      profileCodePermissionCheck.profileCode.SA && firstManager == false) && (
                        <Typography
                          style={{
                            paddingTop: "8px",
                            fontSize: 12,
                            lineHeight: "16px",
                            textAlign: "left",
                            color: "#454545",
                            letterSpacing: "0.1px",
                          }}
                        >
                          <InfoOutlinedIcon
                            style={{
                              fontSize: "14px",
                              verticalAlign: "text-bottom",
                              marginRight: "4px",
                              marginTop: "-1px",
                            }}
                          />

                          Sub-Managers have{" "}

                          <Tooltip
                            title={(
                              <div style={{ fontSize: "12px" }}>
                                Sub-Managers only have access to run transactions and
                                view their own transactions in the Transaction Report page.
                              </div>
                            )}
                            placement="right"
                          >
                            <span
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                            >
                              restricted access
                            </span>
                          </Tooltip>

                          . If you wish to invite a top-level Manager, please contact
                          Viking Admin or Primary Manager.
                        </Typography>
                      )}
                  </div>
                ) : (
                  <div>
                    <FormControl fullWidth>
                      <InputLabel htmlFor="business-name">
                        Manager Type
                      </InputLabel>
                      <Select
                        labelId="business-name"
                        id="business-name"
                        disabled={
                          !businessName ||
                          profileCode ===
                          profileCodePermissionCheck.profileCode.SA
                        }
                        onChange={(e) => {
                          setBusinessType(e.target.value);
                          clearAllFields();
                        }}
                        value={businessType || rowForEdit?.Type}
                        required
                      >
                        {rowForEdit?.Type ? (
                          <MenuItem value={rowForEdit?.Type}>
                            {rowForEdit?.Type === "main"
                              ? "Manager"
                              : rowForEdit?.Type === "sub"
                                ? "Sub Manager"
                                : ""}
                          </MenuItem>
                        ) : (
                          businessTypeValue?.map((row) => (
                            <MenuItem
                              value={`${row.value === "Manager" ? "main" : "sub"
                                }`}
                            >
                              {row.value}
                            </MenuItem>
                          ))
                        )}
                      </Select>
                    </FormControl>
                    {(
                      profileCode ===
                      profileCodePermissionCheck.profileCode.SA) && (
                        <Typography
                          style={{
                            paddingTop: "8px",
                            fontSize: 12,
                            lineHeight: "16px",
                            textAlign: "left",
                            color: "#454545",
                            letterSpacing: "0.1px",
                          }}
                        >
                          <InfoOutlinedIcon
                            style={{
                              fontSize: "14px",
                              verticalAlign: "text-bottom",
                              marginRight: "4px",
                              marginTop: "-1px",
                            }}
                          />

                          Sub-Managers have{" "}

                          <Tooltip
                            title={(
                              <div style={{ fontSize: "14px" }}>
                                Sub-Managers only have access to run transactions and
                                view their own transactions in the Transaction Report page.
                              </div>
                            )}
                            placement="right"
                          >
                            <span
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                            >
                              restricted access
                            </span>
                          </Tooltip>

                          . If you wish to invite a top-level Manager, please contact
                          Viking Admin or Primary Manager.
                        </Typography>
                      )}
                  </div>
                )}
              </div>
              <div>
                <div>
                  <FormControl fullWidth>
                    <InputLabel htmlFor="business-name">Platform </InputLabel>
                    <Select
                      labelId="platform-type"
                      id="platform-type"
                      // disabled={rowForEdit?.Platform_Accessibility || !businessName}
                      onChange={(e) => {
                        setPlatformType(e.target.value);
                      }}
                      value={platformType || rowForEdit?.Platform_Accessibility}
                      required
                    >
                      {platformAccessibility?.map((row) => (
                        <MenuItem value={`${row.value}`}>{row.value}</MenuItem>
                      ))}
                    </Select>
                    {/* <Select
                      labelId="platform-type"
                      id="platform-type"
                      onChange={(e) => {
                        setPlatformType(e.target.value);
                        clearAllFields();
                      }}
                      disabled={!businessName}
                      required
                    >
                      <MenuItem value={`WEB`}>WEB</MenuItem>
                      <MenuItem value={`API`}>API</MenuItem>
                    </Select> */}
                  </FormControl>
                </div>
              </div>
              <div>
                {showCheckbox
                  ? showCheckbox.map((row, index) => (
                    <FormControlLabel
                      key={index}
                      control={(
                        <Checkbox
                          disabled={!businessName}
                          checked={accountAccessibility.some(
                            (item) => item.Service_Code === row.Service_Code
                          )}
                          onChange={(event) =>
                            handleCheckboxChangeRtpAch(
                              event,
                              row.Service_Code
                            )
                          }
                          color="primary"
                        />
                      )}
                      style={{
                        color: "#454545",
                      }}
                      label={`${row.Service_Code}`}
                    />
                  ))
                  : selectedCheckbox?.map((row, index) => (
                    <>
                      <FormControlLabel
                        key={index}
                        control={(
                          <Checkbox
                            disabled={!businessName}
                            checked={accountAccessibility.some(
                              (item) => item.Service_Code === row.Service_Code
                            )}
                            onChange={(event) =>
                              handleCheckboxChangeRtpAch(
                                event,
                                row.Service_Code
                              )
                            }
                            color="primary"
                          />
                        )}
                        style={{
                          color: "#454545",
                        }}
                        label={`${row.Service_Code}`}
                      />
                    </>
                  ))}
                {hasACH && achValue && (<>
                  <Grid
                    container
                    className={classes.margin}
                    style={{ textAlign: "center" }}
                  >
                    <Grid
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "end",
                      }}
                      item
                      lg={8}
                      sm={6}
                      xs={12}
                    >
                      <Button
                        disabled={!achValue}
                        variant="contained"
                        className={classes.buttonStyle}
                        onClick={() => {
                          setLoadingModal(true);
                          setAssignGroupsModal(true);
                          handleAssignGroup({
                            email: selectedEmail || mainEmail,
                            managerId: selectedManagerId || mainManagerId || rowForEdit?.Manager_ID,
                            businessId: selectedBusinessId || rowForEdit?.Bussines_id || Bussines_id,
                          });
                        }}
                      >
                        Assign Merchant Accounts
                      </Button>
                    </Grid>
                    <Grid
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "end",
                      }}
                      item
                      lg={4}
                      sm={6}
                      xs={12}
                    >
                      <Typography
                        style={{
                          marginBottom: "10px",
                          fontWeight: "600",
                          paddingRight: "10px",
                        }}
                      >
                        Selected: {selectedRows?.length} / {tableData?.length}
                      </Typography>
                    </Grid>
                  </Grid>
                </>
                )}
              </div>
              <div
                className={classes.inputRow}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {profileCode === profileCodePermissionCheck.profileCode.VCS ? (
                  <div style={{ width: "100%" }}>
                    <EmailAutofillManager
                      email={email}
                      onEmailChange={handleEmailChange}
                      agentsList={
                        props?.merchantListData?.emailListData?.data || []
                      }
                      selectedUser={selectedUser}
                      setSelectedUser={handleUserSelect}
                      allowManualInput={!props?.merchantListData?.emailData}
                      values={{ businessType }}
                      buttonFlag={buttonFlag}
                    />
                    {/* {props?.merchantListData?.emailData ? (
                      <Typography style={{ display: "flex", color: "#003c6e" }}>
                        <InfoOutlinedIcon fontSize="small" color="action" />
                        &nbsp; Manager exists for another business.
                      </Typography>
                    ) : (
                      ""
                    )} */}
                  </div>
                ) : (
                  <TextField
                    label="Email"
                    type="email"
                    variant="outlined"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    fullWidth
                    InputProps={{
                      inputProps: {
                        style: { textTransform: "lowercase" },
                      },
                    }}
                    disabled={buttonFlag === true ? true : !businessName}
                    onBlur={handleEmailBlur}
                  />
                )}

                <TextField
                  label="Phone Number"
                  variant="outlined"
                  required
                  InputLabelProps={{
                    classes: {
                      root: classes.activeInputLableColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                    required: true,
                  }}
                  value={formatPhoneNumber(phoneNumber)}
                  onChange={(e) => {
                    const formattedNumber = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);
                    setPhone(formattedNumber);
                  }}
                  fullWidth
                // disabled={
                //   buttonFlag == true
                //     ? true
                //     : profileCode ===
                //       profileCodePermissionCheck.profileCode.VCS
                //     ? !businessType
                //     : !businessName
                // }
                />
              </div>
              {platformConflict && (
                <div style={{ width: "100%" }}>
                  <Typography style={{ display: "flex", color: "#b00020" }}>
                    <InfoOutlinedIcon fontSize="small" color="error" />
                    &nbsp; {platformConflict}
                  </Typography>
                </div>
              )}
              <div
                className={classes.inputRow}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <TextField
                  label="First Name"
                  variant="outlined"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                  fullWidth
                  InputProps={{
                    inputProps: {
                      style: { textTransform: "capitalize" },
                    },
                  }}
                // disabled={
                //   buttonFlag == true
                //     ? true
                //     : profileCode ===
                //       profileCodePermissionCheck.profileCode.VCS
                //     ? !businessType
                //     : !businessName
                // }
                />
                <TextField
                  label="Last Name"
                  variant="outlined"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                  fullWidth
                  InputProps={{
                    inputProps: {
                      style: { textTransform: "capitalize" },
                    },
                  }}
                // disabled={
                //   buttonFlag == true
                //     ? true
                //     : profileCode ===
                //       profileCodePermissionCheck.profileCode.VCS
                //     ? !businessType
                //     : !businessName
                // }
                />
              </div>
            </div>
            {buttonFlag === true ? (
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={onFormSubmit}
              >
                Submit{" "}
              </Button>
            ) : (
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isInviteDisabled}
                className={classes.button}
                onClick={onFormSendInvite}
              >
                Send Invite
              </Button>
            )}
          </form>
        </div>
      </Modal>
    </div>
  );
};

// Prop types for the InviteManagerModal component
InviteManagerModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  sendInviteManagerApiCall: PropTypes.func,
  submitManagerApiCall: PropTypes.func,
  getManagerListDataNames: PropTypes.func,
  getMerchantListData: PropTypes.func,
  getEmailList: PropTypes.func,
  emptyGroupCodeReduxState: PropTypes.func,
  getEmailData: PropTypes.func,
  emptyEmailListReduxState: PropTypes.func,
};

// Mapping Redux state to props
const mapStateToProps = (app) => ({
  formData: app.provideRegistration,
  mainData: app,
  roles: app.roles,
  app: app.app,
  signUpData: app,
  merchantListData: app.merchantInformation,
  managerListData: app.generateOfferUser,
  merchantGroupCodeListPortfolios: app.merchantGroupCodeListPortfolios,
});

// Connecting the component to Redux
export default connect(mapStateToProps, {
  sendInviteManagerApiCall,
  submitManagerApiCall,
  getMerchantListData,
  getManagerListDataNames,
  getEmailList,
  getEmailData,
  emptyEmailListReduxState,
  emptyGroupCodeReduxState,
})(InviteManagerModal);
